import { ErrorHandler, Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

import { MobiUiMessageLevel } from '@mobi/rwc-ui-components-ng-jslib';

import { OivCoreSharedFacade } from '../facade/oiv-core-shared.facade';

export class OivError extends Error {
    constructor(message?: string) {
        super(message);
    }
}

@Injectable({
    providedIn: 'root',
})
export class OivErrorHandler implements ErrorHandler {
    #coreSharedFacade = inject(OivCoreSharedFacade);

    #errorMsg = toSignal(this.#coreSharedFacade.translatedMessage('oiv.error.general') as Observable<string>, {
        initialValue: 'An error occurred',
    });

    handleError(error: any): void {
        if (error instanceof OivError) {
            const errorMessage = this.#errorMsg();
            this.#coreSharedFacade.addAlert(
                typeof errorMessage === 'string' ? errorMessage : 'An error occurred',
                MobiUiMessageLevel.ERROR,
            );
        }
    }
}
